var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 210,
    viewBox: "0 0 240 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17226_1790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7783 154.041C33.878 154.041 34.7676 153.151 34.7676 152.052C34.7676 150.952 33.878 150.062 32.7783 150.062C31.6787 150.062 30.7891 150.952 30.7891 152.052C30.7891 153.151 31.6787 154.041 32.7783 154.041Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.769 70.9C144.778 70.9 127.485 70.2089 111.308 65.7034C95.4354 61.2972 80.8615 52.7521 67.872 42.8669C59.3689 36.4332 51.6333 31.2978 40.5911 32.0691C29.7895 32.6532 19.4575 36.6891 11.1186 43.5771C-2.92854 55.8792 -0.817082 78.6738 4.8071 94.6262C13.2491 118.719 38.9493 135.507 60.7893 146.366C86.0198 158.97 113.747 166.297 141.532 170.501C165.889 174.216 197.19 176.897 218.297 161.001C237.682 146.366 243.001 112.999 238.251 90.4682C237.098 83.8131 233.554 77.8071 228.285 73.5803C214.666 63.6149 194.349 70.27 179.042 70.5983C173.361 70.7205 167.572 70.8618 161.769 70.9038V70.9Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.393 173.021C139.051 173.021 149.31 162.761 149.31 150.104C149.31 137.447 139.051 127.188 126.393 127.188C113.736 127.188 103.477 137.447 103.477 150.104C103.477 162.761 113.736 173.021 126.393 173.021Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.708 7.0338C103.975 6.75126 105.285 6.72071 106.564 6.94598C107.843 7.17126 109.065 7.64471 110.161 8.33962C111.257 9.03453 112.204 9.93944 112.952 11.0047C113.696 12.0662 114.227 13.2651 114.51 14.5327L118.171 30.9547L98.8361 35.2654L95.1744 18.8434C94.8919 17.572 94.8613 16.2585 95.0866 14.9756C95.3119 13.6927 95.7892 12.4709 96.4879 11.3713C97.1866 10.2716 98.0992 9.32471 99.1644 8.58016C100.234 7.83562 101.436 7.30871 102.708 7.02998V7.0338Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 2.03127,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.046 135.874L75.541 162.059C74.8117 162.223 74.0519 162.192 73.3379 161.975C72.6239 161.757 71.9786 161.352 71.4632 160.806C70.9516 160.264 70.5888 159.592 70.4132 158.867C70.2376 158.137 70.2566 157.378 70.4666 156.66L70.9554 154.976C75.0141 140.585 78.5459 124.732 75.3005 110.116L68.359 78.9407C62.5134 52.7365 78.2252 26.0436 104.284 19.61C110.638 18.0331 117.247 17.7429 123.715 18.7547C130.183 19.7665 136.384 22.0651 141.954 25.5129C147.521 28.9607 152.344 33.4852 156.139 38.8231C159.934 44.1609 162.618 50.2012 164.043 56.5929L171.209 88.826C174.478 103.442 184.34 116.351 194.206 127.596L195.363 128.917C195.833 129.482 196.15 130.158 196.283 130.879C196.417 131.601 196.367 132.346 196.138 133.041C195.905 133.735 195.501 134.362 194.962 134.858C194.424 135.354 193.763 135.706 193.049 135.877L193.046 135.874Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 2.03127,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.133 115.781C106.103 111.038 107.695 106.43 110.646 102.722C113.598 99.0111 117.733 96.4261 122.361 95.3952C126.988 94.3643 131.83 94.9485 136.079 97.0485C140.329 99.1523 143.731 102.646 145.716 106.953",
    stroke: "#BABABA",
    strokeWidth: 2.03127,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.383 82.8358C143.975 82.8358 145.265 81.5452 145.265 79.953C145.265 78.3609 143.975 77.0703 142.383 77.0703C140.791 77.0703 139.5 78.3609 139.5 79.953C139.5 81.5452 140.791 82.8358 142.383 82.8358Z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6874 92.8045C99.2796 92.8045 100.57 91.514 100.57 89.9218C100.57 88.3296 99.2796 87.0391 97.6874 87.0391C96.0952 87.0391 94.8047 88.3296 94.8047 89.9218C94.8047 91.514 96.0952 92.8045 97.6874 92.8045Z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.435 3.97855C152.534 3.97855 153.424 3.08891 153.424 1.98927C153.424 0.889636 152.534 0 151.435 0C150.335 0 149.445 0.889636 149.445 1.98927C149.445 3.08891 150.335 3.97855 151.435 3.97855Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7783 154.041C33.878 154.041 34.7676 153.151 34.7676 152.052C34.7676 150.952 33.878 150.062 32.7783 150.062C31.6787 150.062 30.7891 150.952 30.7891 152.052C30.7891 153.151 31.6787 154.041 32.7783 154.041Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.406 50.0312V58.7596",
    stroke: "#BABABA",
    strokeWidth: 2.03127,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.039 54.3984H210.767",
    stroke: "#BABABA",
    strokeWidth: 2.03127,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.383 181.438V190.166",
    stroke: "#BABABA",
    strokeWidth: 2.03127,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.016 185.805H214.744",
    stroke: "#BABABA",
    strokeWidth: 2.03127,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7812 16.9453V25.6737",
    stroke: "#BABABA",
    strokeWidth: 2.03127,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4219 21.3125H62.1502",
    stroke: "#BABABA",
    strokeWidth: 2.03127,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.012 209.997C162.164 209.997 195.524 207.916 195.524 205.35C195.524 202.784 162.164 200.703 121.012 200.703C79.8595 200.703 46.5 202.784 46.5 205.35C46.5 207.916 79.8595 209.997 121.012 209.997Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.193 45.0837C192.186 51.2577 189.734 57.1759 185.37 61.5401C181.006 65.9042 175.084 68.3593 168.914 68.3631C168.154 68.3631 167.394 68.3211 166.642 68.241L159.742 79.5046L157.589 65.3964C154.004 63.3995 151.01 60.4901 148.91 56.9659C146.81 53.4379 145.68 49.4211 145.634 45.3166C145.588 41.2121 146.627 37.1686 148.647 33.5986C150.667 30.0248 153.595 27.0504 157.135 24.9733C160.674 22.8962 164.702 21.7928 168.803 21.7737C172.908 21.7546 176.943 22.8199 180.502 24.8626C184.06 26.9053 187.016 29.853 189.07 33.4077C191.124 36.9624 192.201 40.9944 192.193 45.099V45.0799V45.0837Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 2.03127,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.965 47.4382C160.267 47.4382 161.321 46.3844 161.321 45.0824C161.321 43.7804 160.267 42.7266 158.965 42.7266C157.663 42.7266 156.609 43.7804 156.609 45.0824C156.609 46.3844 157.663 47.4382 158.965 47.4382Z",
    fill: "#D2D2D2",
    stroke: "#D2D2D2",
    strokeWidth: 2.03127,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.91 47.4382C170.212 47.4382 171.266 46.3844 171.266 45.0824C171.266 43.7804 170.212 42.7266 168.91 42.7266C167.608 42.7266 166.555 43.7804 166.555 45.0824C166.555 46.3844 167.608 47.4382 168.91 47.4382Z",
    fill: "#D2D2D2",
    stroke: "#D2D2D2",
    strokeWidth: 2.03127,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.856 47.4382C180.158 47.4382 181.212 46.3844 181.212 45.0824C181.212 43.7804 180.158 42.7266 178.856 42.7266C177.554 42.7266 176.5 43.7804 176.5 45.0824C176.5 46.3844 177.554 47.4382 178.856 47.4382Z",
    fill: "#D2D2D2",
    stroke: "#D2D2D2",
    strokeWidth: 2.03127,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17226_1790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 239.381,
    height: 210,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyNotification);
export default __webpack_public_path__ + "static/media/emptyNotification.5f5ca96762262ef51f573bfe35ec941c.svg";
export { ForwardRef as ReactComponent };